import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostStocksDateParams, TypePostStocksDateResponse } from '~/types/stock.types';

const usePostStocksDate = () => {
  const endPoint = '/api-inventory/v1/third-parties/stocks/date';

  const postStocksDate = async (params: TypePostStocksDateParams) => {
    return axiosInstance
      .post<TypePostStocksDateResponse>(endPoint, {
        ...params,
      })
      .then(({ data: { data, pagination } }) => {
        return { data, pagination };
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postStocksDate };
};

export default usePostStocksDate;
